import type { paymentServicesTypes } from '@makemydeal/dr-platform-types';
import { ADDED_FEE_AMOUNT, ADDED_FEE_CODE } from '../components/fees/constants';
import type { CustomFeeItem } from '../components/fees/types';

export const encodeForDataTestId = (val: string) => {
    if (!val) return '';

    return val.trim().split(/\s+/).filter(Boolean).join('_');
};

export const createNewFee = (upfront: boolean, category: paymentServicesTypes.FeeCategory): CustomFeeItem => ({
    capIndicator: upfront,
    category: category,
    feeAmount: ADDED_FEE_AMOUNT,
    feeDescription: '',
    feeName: '',
    feeTypeId: ADDED_FEE_CODE,
    includedInCalc: true,
    isManualFee: true,
    isEdited: true,
    isDeleted: false
});

export const isEveryElementOnSameRow = (childElements: Array<HTMLDivElement | null>): boolean => {
    const topBoundaries = childElements.map((child) => child?.getBoundingClientRect().top).filter(Number.isFinite);

    // if all elements have the same top boundary, they are on the same row
    // otherwise, they are on different rows
    return new Set(topBoundaries).size === 1;
};

export const convertToString = (value?: number, { skipZero = true } = {}): string => {
    if (skipZero && value === 0) {
        return '';
    }

    if (typeof value === 'number' && !isNaN(value)) {
        return value.toFixed(2);
    }

    return '';
};
